import React from 'react'
import abimg from '../../images/about1.png'
import sign from '../../images/signeture.png'


const About = (props) => {
    return(
        <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="wpo-about-section-wrapper">
                    <div className="row align-items-center">
                        <div className="col-lg-5 col-md-12 col-12">
                            <div className="wpo-about-img">
                                <img src={abimg} alt=""/>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-12 col-12">
                            <div className="wpo-about-content">
                                <div className="wpo-section-title-s2">
                                    <h2>Company Profile</h2>
                                </div>
                                <div className="wpo-about-content-inner">
                                    <p>Jagruti Chemicals is a trusted supplier and trading partner offering a wide range of quality chemicals to industries across India. Established in 2024 and headquartered in Vapi, Gujarat, we operate as a proprietary firm dedicated to providing reliable products, consistent service, and ethical business practices.</p>
                                    <p>Backed by years of industry experience, our founder has collaborated with several major chemical companies before establishing this independent manufacturing and trading unit. This strong background allows us to deliver products that match supplier specifications while maintaining competitive pricing and dependable supply.</p>
                                    <p>We cater to diverse industrial sectors with a commitment to quality, transparency, and long-term business relationships.</p>
                                    <div className="signeture">
                                        <h4>SHAH JAGRUTIBEN KIRTIKUMAR</h4>
                                        <p>Jagruti Chemicals, CEO</p>
                                        {/* <span><img src={sign} alt=""/></span> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;